import { isEqual } from "es-toolkit";
import LRUCache from "lru-cache";
const rgbaColorCache = new LRUCache({
    max: 100
});
export const getValidRgbaColor = (color)=>{
    if (rgbaColorCache.has(color)) {
        return rgbaColorCache.get(color);
    }
    const value = _getValidRgbaColor(color);
    rgbaColorCache.set(color, value);
    return value;
};
const hexColorCache = new LRUCache({
    max: 100
});
export const getValidHexColor = (color)=>{
    if (hexColorCache.has(color)) {
        return hexColorCache.get(color);
    }
    const value = _getValidHexColor(color);
    hexColorCache.set(color, value);
    return value;
};
/**
 *  Janky implementations to get a valid rgba color from a string
 *  TODO: Replace with a library
 */ const _getValidRgbaColor = (color)=>{
    let canvas;
    canvas = document.createElement("canvas");
    canvas.height = 1;
    canvas.width = 1;
    let context;
    context = canvas.getContext("2d");
    const rgbaArray = ()=>{
        if (!context) {
            return null;
        }
        /**
     * Turns any valid canvas fillStyle into a 4-element Uint8ClampedArray with bytes
     * for R, G, B, and A. Invalid styles will return [0, 0, 0, 0]. Examples:
     * color_convert.to_rgb_array('red')  # [255, 0, 0, 255]
     * color_convert.to_rgb_array('#ff0000')  # [255, 0, 0, 255]
     * color_convert.to_rgb_array('garbagey')  # [0, 0, 0, 0]
     */ // Setting an invalid fillStyle leaves this unchanged
        context.fillStyle = "rgba(0, 0, 0, 0)";
        // We're reusing the canvas, so fill it with something predictable
        context.clearRect(0, 0, 1, 1);
        context.fillStyle = color;
        context.fillRect(0, 0, 1, 1);
        return context.getImageData(0, 0, 1, 1).data;
    };
    const a = rgbaArray();
    if (!a) return null;
    const alpha = (a[3] / 255).toFixed(2);
    const isAlphaAWholeNumber = Number(alpha) % 1 === 0;
    const data = {
        r: a[0],
        g: a[1],
        b: a[2],
        a: isAlphaAWholeNumber ? Number(parseInt(alpha)) : Number(alpha)
    };
    if (isEqual(data, {
        r: 0,
        g: 0,
        b: 0,
        a: 0
    })) return null;
    return data;
};
const _getValidHexColor = (color)=>{
    let canvas, context;
    canvas = document.createElement("canvas");
    canvas.height = 1;
    canvas.width = 1;
    context = canvas.getContext("2d");
    if (!context) {
        return null;
    }
    context.fillStyle = color;
    return context.fillStyle;
};
